module.exports = __webpack_public_path__ + "static/Aymard.63a83c12.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Aymard.jpeg
// module id = 932
// module chunks = 3